import { VuePlugins } from "./types";
import Vue from "vue";
import { InstallCompendaCardVuePlugin } from "../compenda-integration/src/main";

const installCompendaIntegration = (): void => {
  InstallCompendaCardVuePlugin(Vue);
};

export const installPlugins = (plugins: VuePlugins[]): void => {
  plugins.forEach((plugin): void => {
    switch (plugin) {
      case VuePlugins.CompendaIntegration:
        installCompendaIntegration();
        break;
    }
  });
};
